import { Box, Typography, useTheme } from 'hephaestus/web';
export const SegmentedToggle = ({
  leftLabel,
  rightLabel,
  isRightActive,
  onToggle,
}: {
  leftLabel: string;
  rightLabel: string;
  isRightActive: boolean;
  onToggle: () => void;
}) => {
  const theme = useTheme();
  const segments = [
    { label: leftLabel, active: !isRightActive },
    { label: rightLabel, active: isRightActive },
  ];
  return (
    <Box
      sx={{
        display: 'inline-flex',
        border: '1px solid',
        borderColor: theme.color.outlineVariant,
        borderRadius: '6px',
        overflow: 'hidden',
        userSelect: 'none',
      }}
    >
      {segments.map((seg, idx) => (
        <Box
          key={seg.label}
          onClick={onToggle}
          sx={{
            width: 32,
            height: 28,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            bgcolor: seg.active ? theme.color.primary : 'transparent',
            borderRight: idx === 0 ? '1px solid' : 'none',
            borderColor: theme.color.outlineVariant,
            transition: 'background 0.15s ease',
            '&:hover': {
              bgcolor: seg.active
                ? theme.color.primaryHover
                : theme.color.neutralHover,
            },
          }}
        >
          <Typography
            variant='labelSmall'
            sx={{
              fontWeight: 700,
              fontSize: '0.75rem',
              color: seg.active
                ? theme.color.onPrimary
                : theme.color.onSurfaceVariant,
            }}
          >
            {seg.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export const TogglePill = ({
  label,
  isActive,
  onToggle,
}: {
  label: string;
  isActive: boolean;
  onToggle: () => void;
}) => {
  const theme = useTheme();
  return (
    <Box
      onClick={onToggle}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        border: '1px solid',
        borderColor: isActive
          ? theme.color.primary
          : theme.color.outlineVariant,
        borderRadius: '6px',
        px: 1.5,
        height: 28,
        bgcolor: isActive ? theme.color.primary : 'transparent',
        transition: 'all 0.15s ease',
        userSelect: 'none',
        '&:hover': {
          bgcolor: isActive
            ? theme.color.primaryHover
            : theme.color.neutralHover,
        },
      }}
    >
      <Typography
        variant='labelSmall'
        sx={{
          fontWeight: 600,
          fontSize: '0.7rem',
          color: isActive
            ? theme.color.onPrimary
            : theme.color.onSurfaceVariant,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
